 /**
  * Remove caracteres não numéricos
  */
 function onlyDigits(value: string): string {
   return value.replace(/\D/g, "");
 }
 
 /**
  * Formata CPF: 000.000.000-00
  */
 export function formatCpf(cpf: string): string {
   const digits = onlyDigits(cpf).slice(0, 11);
   
   if (digits.length <= 3) return digits;
   if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
   if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
   return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
 }
 
 /**
  * Formata CNPJ: 00.000.000/0000-00
  */
 export function formatCnpj(cnpj: string): string {
   const digits = onlyDigits(cnpj).slice(0, 14);
   
   if (digits.length <= 2) return digits;
   if (digits.length <= 5) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
   if (digits.length <= 8) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
   if (digits.length <= 12) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8)}`;
   return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
 }
 
 /**
  * Valida CPF brasileiro
  */
 export function isValidCpf(cpf: string): boolean {
   const digits = onlyDigits(cpf);
   
   if (digits.length !== 11) return false;
   
   // Rejeita CPFs com todos os dígitos iguais
   if (/^(\d)\1+$/.test(digits)) return false;
   
   // Valida primeiro dígito verificador
   let sum = 0;
   for (let i = 0; i < 9; i++) {
     sum += parseInt(digits[i]) * (10 - i);
   }
   let remainder = (sum * 10) % 11;
   if (remainder === 10 || remainder === 11) remainder = 0;
   if (remainder !== parseInt(digits[9])) return false;
   
   // Valida segundo dígito verificador
   sum = 0;
   for (let i = 0; i < 10; i++) {
     sum += parseInt(digits[i]) * (11 - i);
   }
   remainder = (sum * 10) % 11;
   if (remainder === 10 || remainder === 11) remainder = 0;
   if (remainder !== parseInt(digits[10])) return false;
   
   return true;
 }
 
 /**
  * Valida CNPJ brasileiro
  */
 export function isValidCnpj(cnpj: string): boolean {
   const digits = onlyDigits(cnpj);
   
   if (digits.length !== 14) return false;
   
   // Rejeita CNPJs com todos os dígitos iguais
   if (/^(\d)\1+$/.test(digits)) return false;
   
   // Valida primeiro dígito verificador
   const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
   let sum = 0;
   for (let i = 0; i < 12; i++) {
     sum += parseInt(digits[i]) * weights1[i];
   }
   let remainder = sum % 11;
   const firstVerifier = remainder < 2 ? 0 : 11 - remainder;
   if (firstVerifier !== parseInt(digits[12])) return false;
   
   // Valida segundo dígito verificador
   const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
   sum = 0;
   for (let i = 0; i < 13; i++) {
     sum += parseInt(digits[i]) * weights2[i];
   }
   remainder = sum % 11;
   const secondVerifier = remainder < 2 ? 0 : 11 - remainder;
   if (secondVerifier !== parseInt(digits[13])) return false;
   
   return true;
 }
 
 /**
  * Formata telefone brasileiro: (00) 00000-0000 ou (00) 0000-0000
  */
 export function formatPhone(phone: string): string {
   const digits = onlyDigits(phone).slice(0, 11);
   
   if (digits.length === 0) return "";
   if (digits.length <= 2) return `(${digits}`;
   if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
   if (digits.length <= 10) {
     return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
   }
   return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
 }
 
 /**
  * Remove formatação e retorna apenas dígitos
  */
 export function sanitizeDocument(value: string): string {
   return onlyDigits(value);
 }